import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyAction,
    LazyModule,
    registerLazyOrchestrator,
    type LazyComponent,
} from 'owa-bundling';
import renderMeetingPreviewPlaceHolder from './components/MailListItemMeetingPreviewPlaceholder';
import { onModuleClick } from 'owa-workloads';
import { BigHoverActionPlaceholder } from 'owa-mail-list-view-bighoveraction';
import type { BigHoverActionProps } from './components/BigHoverAction/BigHoverAction';
import type { SelectAllCheckboxProps } from './components/SelectAllCheckbox';
import type { MailPersonaSearchResultsHeaderProps } from './components/listHeaders/MailPersonaSearchResultsHeader';
import type { CopilotResultsTabProps } from './components/listHeaders/CopilotResultsTab';
import type { SearchResultsTabProps } from './components/listHeaders/SearchResultsTab';
import type { MailListItemMeetingPreviewProps } from './components/MailListItemMeetingPreview';
import type { MailListItemExpansionProps } from './components/MailListItemExpansion';
import type { MailListNudgeHostProps } from './components/nudges/MailListNudgeHost';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailListItemLazy"*/ './lazyIndex'),
    { name: 'MailListItemLazy' }
);

// Delayed Loaded Components
export const MailListItemExpansion: LazyComponent<MailListItemExpansionProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListItemExpansion);
export const MailListItemMeetingPreview: LazyComponent<
    MailListItemMeetingPreviewProps,
    unknown,
    void
> = createLazyComponent(
    lazyModule,
    m => m.MailListItemMeetingPreview,
    () => renderMeetingPreviewPlaceHolder()
);
export const MailPersonaSearchResultsHeader: LazyComponent<
    MailPersonaSearchResultsHeaderProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.MailPersonaSearchResultsHeader);

export const CopilotResultsTab: LazyComponent<CopilotResultsTabProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotResultsTab);

export const SearchResultsTab: LazyComponent<SearchResultsTabProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.SearchResultsTab);

export const MailListItemNoMoreRowsMessageBar: typeof lazyIndex.MailListItemNoMoreRowsMessageBar =
    createLazyComponent(lazyModule, m => m.MailListItemNoMoreRowsMessageBar);

registerLazyOrchestrator(onModuleClick, lazyModule, m => m.onModuleClickOrchestrator);

export const SelectAllCheckbox: LazyComponent<SelectAllCheckboxProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.SelectAllCheckbox);

export const BigHoverAction: LazyComponent<BigHoverActionProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.BigHoverAction, BigHoverActionPlaceholder);

export const lazySetupTriageActionKeys: LazyAction<
    typeof lazyIndex.setupTriageActionKeys,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupTriageActionKeys);

// Single host that owns nudge mutual-exclusion + priority. Bundles all
// individual nudge implementations into the MailListItemLazy chunk.
export const MailListNudgeHost: LazyComponent<MailListNudgeHostProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListNudgeHost);
